export default __webpack_public_path__ + "b5425d1ad6d0638579390bec5df88a0c.svg";